<template>
  <div>
    <!-- Gurudwara list -->
    <div class="">
      <div class="gurudwara-quick-cards" :style="{ '--quick-card-count': quickCards.length }">
        <button
          v-for="card in quickCards"
          :key="card.key"
          type="button"
          class="gurudwara-quick-card"
          @click="openQuickCard(card)"
        >
          <span class="gurudwara-quick-card-count">{{ card.count }}</span>
          <span class="gurudwara-quick-card-copy">
            <span class="gurudwara-quick-card-label">{{ card.label }}</span>
            <feather-icon icon="ChevronRightIcon" svgClasses="w-5 h-5 stroke-current" />
          </span>
        </button>
      </div>
      <vs-table
        id="gurudwara-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              v-if="checkPermissionSlug(['gurudwara_create'])"
              @click="addPage"
              class="btn-add-new p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium border border-solid d-theme-border-grey-light"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base">Add {{ module_name }}</span>
            </div>

            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <!-- <vs-th sort-key="Gurudwara.name">Vertical Thumbnail</vs-th> -->
          <vs-th sort-key="Gurudwara.name">Gurudwara Name</vs-th>
          <vs-th>Admin Mail</vs-th>
          <vs-th sort-key="Gurudwara.country.country_name">Country</vs-th>
          <vs-th sort-key="Gurudwara.state.name">State</vs-th>
          <vs-th sort-key="Gurudwara.city.name">City</vs-th>
          <vs-th v-if="checkRolesByIds(['admin'])">Index</vs-th>
          <!-- <vs-th v-if="checkPermissionSlug(['gurudwara_edit'])" sort-key="status">Featured</vs-th> -->
          <vs-th v-if="checkPermissionSlug(['gurudwara_edit'])" sort-key="status">Visible</vs-th>
          <vs-th v-if="checkPermissionSlug(['gurudwara_youtube_live'])">Youtube Live</vs-th>
          <vs-th v-if="showRowActions">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <!-- <vs-td>
              <img :src="tr.vertical_thumbnail" height="100" width="100" alt="" srcset="" />
            </vs-td> -->
              <vs-td class="text-left">
                <span class="cursor-pointer" v-if="checkPermissionSlug(['gurudwara_edit'])" @click.stop="toggleEditGurudwaraModal(tr._id, $event)" v-tooltip="{ content: `Edit ${tr.name}` }">{{
                  tr.name || '-'
                }}</span>
                <span v-else>{{ tr.name || '-' }}</span>
              </vs-td>
              <vs-td class="text-left">
                <ul>
                  <li v-for="(value, index) in tr.admin" :key="index">
                    {{ value.email }}
                  </li>
                </ul>
              </vs-td>
              <vs-td class="text-left">
                <p class="capitalize">{{ tr.country ? tr.country.country_name : '-' }}</p>
              </vs-td>
              <vs-td class="text-left">
                <p class="capitalize">{{ tr.state ? tr.state.name : '-' }}</p>
              </vs-td>
              <vs-td>
                <p class="capitalize">{{ tr.city ? tr.city.name : '-' }}</p>
              </vs-td>
              <vs-td class="text-left w-1/6" v-if="checkRolesByIds(['admin'])">
                <vs-input
                  v-if="tr.is_active"
                  v-model="tr.featured_index"
                  v-validate="'required'"
                  type="number"
                  class="w-1/2"
                  @click.stop
                  @keydown.enter="updateIndexPosition(tr._id, tr.featured_index)"
                />
                <span v-else> - </span>
              </vs-td>
              <!-- <vs-td v-if="checkPermissionSlug(['gurudwara_edit'])">
                <vs-switch
                  icon-pack="feather"
                  vs-icon-on="icon-check-circle"
                  vs-icon-off="icon-slash"
                  color="primary"
                  :value="tr.is_featured"
                  @click.stop="updateFeaturedStatus(tr._id, !tr.is_featured)"
                >
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td> -->
              <vs-td v-if="checkPermissionSlug(['gurudwara_edit'])">
                <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['gurudwara_youtube_live'])">
                <vs-checkbox
                  icon-pack="feather"
                  icon="icon-youtube"
                  :value="tr.go_live_on_youtube"
                  @click.native.stop="proccedLiveYoutube(tr._id, !tr.go_live_on_youtube)"
                  color="danger"
                ></vs-checkbox>
              </vs-td>
              <vs-td v-if="showRowActions">
                <div class="gurudwara-list-actions">
                  <button
                    v-if="canBookSarai"
                    type="button"
                    class="gurudwara-list-action-btn"
                    @click.stop="openBookSarai(tr)"
                  >
                    Book Sarai
                  </button>
                  <button
                    v-if="canBookService"
                    type="button"
                    class="gurudwara-list-action-btn"
                    @click.stop="openBookService(tr)"
                  >
                    Book Service
                  </button>
                  <vs-dropdown v-if="showActionsDropdown" vs-trigger-click class="cursor-pointer gurudwara-list-actions-dropdown">
                    <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                      Actions
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu class="locations__actions">
                    <!-- <vs-dropdown-item v-if="checkPermissionSlug(['gurudwara_invite_gurudwara']) && !tr.admin" @click.stop="inviteMember(tr._id)">
                      <feather-icon icon="SendIcon" svgClasses="h-5 w-5  mr-4 hover:text-primary cursor-pointer" /> Invite Gurudwara Admin
                    </vs-dropdown-item> -->
                    <vs-dropdown-item v-if="checkPermissionSlug(['gurudwara_admin_list'])" @click.stop="manageGurudwaraAdmin(tr._id)">
                      <feather-icon icon="SendIcon" svgClasses="h-5 w-5  mr-4 cursor-pointer" /> Manage Gurudwara Admin
                    </vs-dropdown-item>

                    <vs-dropdown-item v-if="checkPermissionSlug(['service_request_list'])" @click.stop="toggleServiceReq(tr._id)">
                      <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5 mr-4 cursor-pointer" /> Service Requests List
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="checkPermissionSlug(['gurudwara_edit', 'gurudwara_view'])" @click.stop="toggleEditGurudwaraModal(tr._id, $event)">
                      <feather-icon :icon="checkPermissionSlug(['gurudwara_edit']) ? 'EditIcon' : 'EyeIcon'" svgClasses="h-5 w-5 mr-4 cursor-pointer" />
                      {{ checkPermissionSlug(['gurudwara_edit']) ? 'Edit' : 'View' }} Gurudwara
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="checkPermissionSlug(['gurudwara_delete'])" @click.stop="deleteRecord(tr._id)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 cursor-pointer" /> Delete
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <sarai-bookings
        v-if="saraiBookingGurudwaraId"
        :override-gurudwara-id="saraiBookingGurudwaraId"
        :dialog-only="true"
        @close="closeBookSarai"
      />
      <slot-master-modal
        v-if="serviceBookingGurudwaraId"
        :show-modal="serviceBookingOpen"
        :override-gurudwara-id="serviceBookingGurudwaraId"
        :dialog-only="true"
        @update:showModal="onServiceBookingModalUpdate"
      />
      <!-- <vs-popup button-accept="false" button-cancel="false" :active.sync="popupActive" :title="`Invite Gurudwara Admin`" class="small_modal">
        <div class="vx-row px-5 vs-con-loading__container">
          <div class="vx-col px-0 w-full">
            <div class="mt-2 mb-3">
              <label for="Email">Mail</label>
              <vs-input id="Email" class="w-full" v-model="form.email" v-validate="'required|min:1|email'" name="Email" icon="icon icon-mail" icon-pack="feather" placeholder="Please add Email" />
              <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
            </div>
            <div class="mt-4">
              <div class="w-full px-0 justify-items-center">
                <vs-button class="text-sm py-3 px-5" color="dark" @click.stop="inviteMember()"> Cancel </vs-button>
                <button
                  id="invite-gurudwara"
                  class="ml-2 vs-con-loading__container text-sm vs-component vs-button vs-button-primary vs-button-filled py-3 px-5"
                  @click.stop="inviteGuruAdmin"
                  type="submit"
                >
                  Invite
                </button>
              </div>
            </div>
          </div>
        </div>
      </vs-popup> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import SaraiBookings from '@/views/gurudwara/sarai/SaraiBookings.vue'
import slotMasterModal from '@/views/gurudwara/service/slotMaster.vue'
import { isGurudwaraAdminPortal } from '@/utils/portalGurudwara'

export default {
  name: 'GurudwaraList',
  components: {
    SaraiBookings,
    slotMasterModal
  },

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    form: {
      email: '',
      gurudwara: ''
    },
    checkBox2: false,
    popupActive: false,
    module_name: 'Gurudwara',
    saraiBookingGurudwaraId: null,
    serviceBookingGurudwaraId: null,
    serviceBookingOpen: false
  }),

  /** computed */
  computed: {
    ...mapState('gurudwara', ['records', 'total', 'FilteredCount', 'listLoading', 'createLoading']),
    ...mapState('auth', ['roles']),
    ...mapState('adminNotifications', ['quickCounts']),
    ...mapState('feedback', { appFeedbackCount: 'unreadCount' }),
    ...mapState('book', { bookFeedbackCount: 'unreadCount' }),
    ...mapGetters('auth', ['checkPermissionSlug', 'checkRolesByIds']),
    validateForm() {
      return !this.errors.any()
    },
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    },
    canBookSarai() {
      return this.checkPermissionSlug(['stay_edit', 'stay_view'])
    },
    canBookService() {
      return this.checkPermissionSlug([
        'available_service_list',
        'available_service_create',
        'available_service_edit',
        'available_service_view',
        'gurudwara_service_view',
        'gurudwara_service_create',
        'gurudwara_service_edit',
        'gurudwara_service_booking_view',
        'gurudwara_service_booking_create'
      ])
    },
    showActionsDropdown() {
      return this.checkPermissionSlug(['gurudwara_edit', 'gurudwara_admin_list', 'gurudwara_delete', 'gurudwara_view'])
    },
    showRowActions() {
      return this.canBookSarai || this.canBookService || this.showActionsDropdown
    },
    showFeedbackQuickCards() {
      return this.checkRolesByIds(['admin', 'support_administrator'])
    },
    quickCards() {
      const counts = this.quickCounts || {}
      const onGurudwaraPortal = isGurudwaraAdminPortal()
      const cards = [
        { key: 'prasad', count: counts.prasad || 0, label: 'New Prasad Bookings', kind: 'service' },
        { key: 'sarai', count: counts.sarai || 0, label: 'New Sarai Bookings', kind: 'sarai' },
        { key: 'service', count: counts.service || 0, label: 'New Service Bookings', kind: 'service' },
        ...(onGurudwaraPortal
          ? []
          : [{ key: 'hotel', count: counts.hotel || 0, label: 'New Hotel Bookings', kind: 'hotel' }]),
        { key: 'anandKaraj', count: counts.anandKaraj || 0, label: 'New Anand Karaj Bookings', kind: 'service' }
      ]
      if (this.showFeedbackQuickCards) {
        cards.push(
          { key: 'bookFeedback', count: this.bookFeedbackCount || 0, label: 'New Feedback on Books', kind: 'books' },
          { key: 'appFeedback', count: this.appFeedbackCount || 0, label: 'New App Feedback', kind: 'feedback' }
        )
      }
      return cards
    }
  },

  /** Functions */
  methods: {
    ...mapActions('gurudwara', {
      get: 'get',
      delete: 'delete'
      // inviteAdmin: 'inviteAdmin'
    }),

    /** Update General-Index */
    updateIndexPosition(id, featured_index) {
      if (featured_index > 0) {
        this.$store
          .dispatch('gurudwara/manageIndexNumber', { id, featured_index })
          .then((Success) => {
            const { message } = Success
            this.getData()
            this.$vs.notify({
              title: 'Success',
              text: message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              position: 'top-center',
              time: 5000,
              color: 'success'
            })
          })
          .catch((err) => {
            const { message } = err
            this.$vs.notify({
              title: 'Error',
              text: message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              position: 'top-center',
              time: 5000,
              color: 'primary'
            })
          })
      }
    },

    inviteMember(id) {
      this.form.gurudwara = id
      if (this.popupActive) {
        this.popupActive = false
      } else {
        this.popupActive = true
      }
    },

    manageGurudwaraAdmin(id) {
      this.$router.push(`/gurudwara/${id}/gurudwara-admin-list`)
    },

    openBookSarai(row) {
      this.saraiBookingGurudwaraId = row && row._id ? String(row._id) : null
    },

    closeBookSarai() {
      this.saraiBookingGurudwaraId = null
    },

    openBookService(row) {
      this.serviceBookingGurudwaraId = row && row._id ? String(row._id) : null
      this.serviceBookingOpen = true
    },

    onServiceBookingModalUpdate(val) {
      this.serviceBookingOpen = val
      if (!val) {
        this.serviceBookingGurudwaraId = null
      }
    },

    async openQuickCard(card) {
      if (card.kind === 'books') {
        this.$router.push('/book/list').catch(() => {})
        return
      }
      if (card.kind === 'feedback') {
        this.$router.push('/feedback/list').catch(() => {})
        return
      }
      if (card.kind === 'sarai' || card.key === 'sarai') {
        this.$router.push({ path: '/gurudwara/sarai/bookings', query: { from: 'list', focus: 'pending', open: String(Date.now()) } }).catch(() => {})
        return
      }
      if (card.kind === 'hotel' || card.key === 'hotel') {
        this.$router.push({
          path: '/hotel/bookings',
          query: { from: 'list', focus: 'pending', open: String(Date.now()) }
        }).catch(() => {})
        return
      }
      if (card.key === 'prasad' || card.key === 'anandKaraj' || card.key === 'service') {
        this.$router.push({
          path: '/gurudwara/service/bookings',
          query: { from: 'list', bookingKind: card.key, open: String(Date.now()) }
        }).catch(() => {})
        return
      }
    },

    onHeaderRefresh() {
      this.getData()
      this.$store.dispatch('adminNotifications/fetchQuickCounts')
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    // Add Gurudwara modal
    addPage() {
      this.$router.push(`/gurudwara/add`)
    },

    // Edit Gurudwara modal
    toggleEditGurudwaraModal(id, event) {
      const editUrl = `/gurudwara/${id}/edit`

      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    // Gurudwara Service Req
    toggleServiceReq(id) {
      this.$router.push(`/gurudwara/${id}/service-req-list`)
    },

    // Gurudwara Contact Us Details
    toggleContact(id) {
      this.$router.push(`/gurudwara/${id}/contact-us-list`)
    },

    // Gurudwara FAQ
    toggleFAQ(id) {
      this.$router.push(`/gurudwara/${id}/faq-list`)
    },

    /** Daily Routine Navigate */
    toggleDailyRoutine(id) {
      this.$router.push(`/gurudwara/${id}/daily-routine-list`)
    },

    /** Daily Graphic Navigate */
    toggleGraphicManage(id) {
      this.$router.push(`/gurudwara/${id}/graphics-action`)
    },

    /** Delete Gurudwara Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete Gurudwara API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** updateStatus API */
    updateStatus(id, status) {
      this.$store
        .dispatch('gurudwara/updateStatus', {
          id,
          status
        })
        .then((Success) => {
          this.getData()
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    },

    /** Youtube Live Mgmt  */
    proccedLiveYoutube(id, status) {
      this.$store
        .dispatch('gurudwara/youtubeLiveHandle', {
          id,
          status
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    },

    /** updateStatus API */
    updateFeaturedStatus(id, status) {
      this.$store
        .dispatch('gurudwara/featuredStatus', {
          id,
          status
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    }

    /** Invite Admin */
    // async inviteGuruAdmin() {
    //   if (!(await this.$validator.validate())) {
    //     this.$vs.notify({
    //       title: 'Error',
    //       text: 'Please fix the error first',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       position: 'top-center',
    //       time: 5000,
    //       color: 'primary'
    //     })
    //     return false
    //   }
    //   try {
    //     const { message } = await this.inviteAdmin(this.form)
    //     this.form = {}
    //     this.$vs.notify({
    //       title: 'Success',
    //       text: message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       position: 'top-center',
    //       time: 5000,
    //       color: 'success'
    //     })
    //     this.popupActive = false
    //   } catch ({ message }) {
    //     this.$vs.notify({
    //       title: 'Error',
    //       text: message,
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       position: 'top-center',
    //       time: 5000,
    //       color: 'primary'
    //     })
    //   }
    // }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#gurudwara-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#gurudwara-list > .con-vs-loading')
      }
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#invite-gurudwara',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#invite-gurudwara > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
    this.$store.dispatch('adminNotifications/fetchQuickCounts')
    this.$store.dispatch('feedback/getUnreadCount')
    this.$store.dispatch('book/getUnreadCount')
    this.$root.$on('admin-header-refresh', this.onHeaderRefresh)
  },
  beforeDestroy() {
    this.$root.$off('admin-header-refresh', this.onHeaderRefresh)
    this.$vs.loading.close('#gurudwara-list > .con-vs-loading')
  }
}
</script>
<style lang="scss">
.locations__actions {
  width: 300px;
}

.gurudwara-list-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
  max-width: 420px;
}

.gurudwara-quick-cards {
  display: grid;
  grid-template-columns: repeat(var(--quick-card-count, 6), minmax(0, 1fr));
  margin: 0 0 24px;
  padding: 4px 0 20px;
  border-bottom: 1px solid var(--divider);
}

.gurudwara-quick-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  padding: 8px 18px;
  border: 0;
  border-right: 1px solid var(--divider);
  background: transparent;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
}

.gurudwara-quick-card:last-child {
  border-right: 0;
}

.gurudwara-quick-card:hover {
  opacity: 0.8;
}

.gurudwara-quick-card-count {
  font-size: 32px;
  line-height: 1.1;
  font-weight: 700;
}

.gurudwara-quick-card-copy {
  display: flex;
  align-items: center;
  gap: 4px;
}

.gurudwara-quick-card-label {
  font-size: 14px;
  font-weight: 500;
}

.gurudwara-list-action-btn {
  white-space: nowrap;
  padding: 10px 14px;
  border: 1px solid #111;
  background: #111;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.gurudwara-list-action-btn:hover {
  background: #000;
  color: #fff;
}

.gurudwara-list-actions-dropdown {
  flex: 0 0 auto;
}

@media (max-width: 1280px) {
  .gurudwara-list-actions {
    max-width: 280px;
  }

  .gurudwara-list-action-btn {
    padding: 8px 10px;
    font-size: 13px;
  }

  .gurudwara-list-actions-dropdown .p-4 {
    padding: 8px 10px !important;
  }
}

@media (max-width: 1024px) {
  .gurudwara-list-actions {
    max-width: 220px;
    justify-content: flex-start;
  }

  .gurudwara-quick-cards {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .gurudwara-quick-card:nth-child(3n) {
    border-right: 0;
  }

  .gurudwara-quick-card:nth-child(-n + 3) {
    padding-bottom: 16px;
    margin-bottom: 8px;
    border-bottom: 1px solid var(--divider);
  }
}

@media (max-width: 640px) {
  .gurudwara-quick-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .gurudwara-quick-card {
    border-right: 1px solid var(--divider);
    border-bottom: 1px solid var(--divider);
    margin-bottom: 0;
    padding-bottom: 12px;
  }

  .gurudwara-quick-card:nth-child(3n),
  .gurudwara-quick-card:nth-child(-n + 3) {
    border-right: 1px solid var(--divider);
    border-bottom: 1px solid var(--divider);
  }

  .gurudwara-quick-card:nth-child(2n) {
    border-right: 0;
  }

  .gurudwara-quick-card:nth-last-child(-n + 2) {
    border-bottom: 0;
  }
}
</style>
